/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedContactDealerWrapper_user = {
    readonly serviceId: string | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "SharedContactDealerWrapper_user";
};
export type SharedContactDealerWrapper_user$data = SharedContactDealerWrapper_user;
export type SharedContactDealerWrapper_user$key = {
    readonly " $data"?: SharedContactDealerWrapper_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedContactDealerWrapper_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'ed3b236b1f1d92ed75de332348a5887d';
export default node;
